/**
 * Écran de bienvenue — première chose vue après l'échange du jeton d'accès.
 *
 * Contient le formulaire de profil (contrainte : moins de 2 minutes) et les
 * cases de consentement, séparées et jamais pré-cochées (section 6). Un
 * participant dont le profil est déjà complet est redirigé directement vers
 * l'accueil : cet écran ne se revoit pas à chaque connexion.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../etat.tsx';
import { useLibelles } from '../i18n.tsx';
import { envoyer } from '../reseau.ts';
import { FormulaireProfil } from '../composants/FormulaireProfil.tsx';
import { CaseConsentement } from '../composants/Formulaires.tsx';

export function Bienvenue() {
  const { moi, consentements, recharger } = useSession();
  const { t } = useLibelles();
  const naviguer = useNavigate();
  const [cgu, setCgu] = useState(false);
  const [partage, setPartage] = useState(consentements.partage_coordonnees ?? false);
  const [diagnostic, setDiagnostic] = useState(false);

  const continuer = async () => {
    if (cgu) await envoyer('/api/rgpd/consentements', { type: 'cgu', accorde: true });
    await envoyer('/api/rgpd/consentements', { type: 'partage_coordonnees', accorde: partage });
    if (diagnostic) await envoyer('/api/rgpd/consentements', { type: 'diagnostic_ia', accorde: true });
    await recharger();
    naviguer('/', { replace: true });
  };

  return (
    <div className="bienvenue">
      <h1>
        Bienvenue{moi?.prenom ? `, ${moi.prenom}` : ''}
      </h1>
      <p className="bienvenue__evenement">{moi?.evenement_nom}</p>

      <FormulaireProfil />

      <section className="carte consentements" aria-labelledby="titre-consentements">
        <h2 id="titre-consentements">{t('rgpd.centre.titre', 'Vos données')}</h2>

        <CaseConsentement
          texte={t('rgpd.cgu.texte', "J'accepte les conditions d'utilisation.")}
          coche={cgu}
          onChange={setCgu}
        />

        <CaseConsentement
          texte={t(
            'rgpd.partage_coordonnees.texte',
            "J'autorise le partage de mes coordonnées avec les participants avec qui j'établis une mise en relation.",
          )}
          coche={partage}
          onChange={setPartage}
        />

        <CaseConsentement
          texte={t('rgpd.diagnostic_ia.texte', 'Je souhaite mon diagnostic IA gratuit.')}
          coche={diagnostic}
          onChange={setDiagnostic}
        />

        <p className="consentements__note">
          {t('rgpd.centre.hebergement', "Vos données sont hébergées dans l'Union européenne.")}
        </p>
      </section>

      <button className="bouton bienvenue__continuer" disabled={!cgu} onClick={() => void continuer()}>
        Continuer
      </button>
    </div>
  );
}
